module.exports = __webpack_public_path__ + "img/logo_mini.74a81009.png";